// extracted by mini-css-extract-plugin
export default {"messages":"Messages_messages__w2CtC","messages-main":"Messages_messages-main__HV4cm","messages-closed":"Messages_messages-closed__iiPbG","error":"Messages_error__EinjH"};